<template>
  <transition name="modal-fade">
    <div v-if="show" class="modal-overlay" @click.self="close">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title-wrapper">
            <i class="fas fa-exclamation-triangle warning-icon"></i>
            <h5 class="modal-title">Important: Wallet Connection</h5>
          </div>
          <button type="button" class="close-button" @click="close">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div class="wallet-warning-message">
            <p>
              If you have downloaded the <strong>ExaDrive Android App</strong>,
              please use the <strong>same wallet address</strong> that you used
              to log in to the ExaDrive App.
            </p>
            <div class="warning-box">
              <i class="fas fa-lock"></i>
              <div>
                <strong>Please note:</strong>
                <p>
                  You cannot change the wallet once it has been connected and
                  verified.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <soft-button
            color="secondary"
            variant="outline"
            size="sm"
            @click="close"
            class="cancel-btn"
          >
            Cancel
          </soft-button>
          <soft-button
            color="primary"
            variant="gradient"
            size="sm"
            @click="proceed"
            class="proceed-btn"
          >
            <i class="fas fa-wallet me-1"></i>
            Proceed to Connect
          </soft-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import SoftButton from "@/components/SoftButton.vue";

const props = defineProps({
  show: Boolean,
});

const emit = defineEmits(["close", "proceed"]);

const close = () => {
  emit("close");
};

const proceed = () => {
  emit("proceed");
};
</script>

<style scoped>
/* Animation */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(3px);
}

.modal-content {
  background: white;
  padding: 0;
  border-radius: 0.75rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 500px;
  overflow: hidden;
  animation: modal-appear 0.3s ease-out;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.modal-title-wrapper {
  display: flex;
  align-items: center;
}

.warning-icon {
  color: #fb6340;
  font-size: 1.25rem;
  margin-right: 0.75rem;
}

.modal-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #344767;
  margin-bottom: 0;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6c757d;
  transition: color 0.2s;
}

.close-button:hover {
  color: #343a40;
}

.modal-body {
  padding: 1.5rem;
}

.wallet-warning-message p {
  font-size: 0.95rem;
  color: #344767;
  line-height: 1.5;
  margin-bottom: 1.25rem;
}

.warning-box {
  display: flex;
  align-items: flex-start;
  background-color: rgba(251, 99, 64, 0.1);
  border-left: 3px solid #fb6340;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-top: 1rem;
}

.warning-box i {
  color: #fb6340;
  font-size: 1.1rem;
  margin-right: 0.75rem;
  margin-top: 0.15rem;
}

.warning-box div {
  flex: 1;
}

.warning-box strong {
  color: #fb6340;
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.warning-box p {
  margin: 0;
  font-size: 0.9rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  border-top: 1px solid #e9ecef;
  padding: 1.25rem 1.5rem;
  background-color: #f8f9fa;
}

.cancel-btn,
.proceed-btn {
  min-width: 120px;
  text-transform: none;
  letter-spacing: 0;
}

.proceed-btn {
  font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .modal-content {
    width: 95%;
  }

  .modal-footer {
    flex-direction: column-reverse;
  }

  .modal-footer .cancel-btn,
  .modal-footer .proceed-btn {
    width: 100%;
  }
}
</style>
